import React from 'react'

export const setCodeToElement = (set: string, rarity: string, className?: string) => {
  if (!set || !rarity) return <i className={className} />

  const iconClassName = `ss ss-${set.toLowerCase()} ss-${rarity.toLowerCase()} `

  return <i className={`${iconClassName} ${className}`} style={{ fontSize: '150%' }} />
}
